import Permissions from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import { useProviderRiskLabel } from '@app/src/hooks/useProviderRiskLabel'
import { insertIf } from '@app/src/utils/helpersTs'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './MenuWrapper'
import MenuWrapper from './MenuWrapper'

const AnalyzeMenu: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { evaluations, topicalRisk } = useFlags()
  const providerRiskLabel = useProviderRiskLabel()

  const menuItems: MenuWrapperProps['menuItems'] = [
    {
      title: formatMessage({ id: 'navbar.dataHub' }),
      link: navigationLinks.responseItems,
      permission: Permissions.DATA_HUB_ACCESS,
    },
    ...insertIf(evaluations, {
      title: formatMessage({ id: 'navbar.evaluations' }),
      link: navigationLinks.evaluations,
      permission: Permissions.EVALUATION_ACCESS,
    }),
    ...insertIf(!topicalRisk, {
      title: providerRiskLabel,
      link: navigationLinks.providerRisk,
      permission: Permissions.PROVIDER_RISK_ACCESS,
    }),
    {
      title: formatMessage({ id: 'navbar.riskScreening' }),
      link: navigationLinks.riskScreeningHq,
    },
    ...insertIf(topicalRisk, {
      title: providerRiskLabel,
      link: navigationLinks.topicalRisk,
      permission: Permissions.PROVIDER_RISK_ACCESS,
    }),
    {
      title: formatMessage({ id: 'navbar.findings' }),
      link: navigationLinks.findings,
      permission: [Permissions.SOURCING_USER, Permissions.FINANCE_USER, Permissions.INVESTMENT_USER],
    },
  ]

  return <MenuWrapper icon={icon} menuItems={menuItems} title={formatMessage({ id: 'navbar.analyze' })} />
}

export default AnalyzeMenu
